import classNames from 'classnames'
import React from 'react'
import { TableCellProps } from 'react-table'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles } from 'utils-next/types'

import { TableCell, Theme } from '@mui/material'

import { TableColumn } from './Table.hooks'

export type TableRowCellProps = ExtendableStyles &
  TableCellProps & {
    render: (type: 'Cell' | string, userProps?: object) => React.ReactNode
    column: TableColumn<any>
    onClick?: () => void
  }

export function TableRowCell({ className, column: { preventEvents }, style, onClick, render }: TableRowCellProps) {
  const { classes } = useStyles()
  return (
    <TableCell
      component="td"
      className={classNames(classes.tableRowCell, className)}
      style={style}
      onClick={!preventEvents ? onClick : undefined}
    >
      {render('Cell')}
    </TableCell>
  )
}

const useStyles = makeStyles()(({ typography }: Theme) => ({
  tableRowCell: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    ...(typography.body1 as any),
  },
  cell: {
    position: 'relative',
    zIndex: 2,
  },
  clickHandler: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
}))
